import { TextFieldProperties } from "./TextFieldProperties";
/**
 * BitmapTextFieldProperties.ts
 */
export class BitmapTextFieldProperties extends TextFieldProperties {
    constructor(bitmapStyle, fallbackStyle, position = null, langKey = null, horizontalAlign, verticalAlign, size) {
        super(fallbackStyle, position, langKey, horizontalAlign, verticalAlign, size);
        this.bitmapTextStyle = bitmapStyle;
    }
    equals(other) {
        return super.equals(other) &&
            this.bitmapTextStyle.fontName === other.bitmapTextStyle.fontName &&
            this.bitmapTextStyle.fontSize === other.bitmapTextStyle.fontSize &&
            this.bitmapTextStyle.align === other.bitmapTextStyle.align &&
            this.bitmapTextStyle.tint === other.bitmapTextStyle.tint &&
            this.bitmapTextStyle.letterSpacing === other.bitmapTextStyle.letterSpacing &&
            this.bitmapTextStyle.maxWidth === other.bitmapTextStyle.maxWidth;
    }
    copyTo(style, bitmapStyle) {
        return new BitmapTextFieldProperties(bitmapStyle ? bitmapStyle : this.bitmapTextStyle, style, this.position?.clone(), this.langKey, this.horizontalAlign, this.verticalAlign, this.size?.clone());
    }
}
//# sourceMappingURL=BitmapTextFieldProperties.js.map